import fetchWithCache from './fetchWithCache';
import normalizeModelMatrix from './normalizeModelMatrix';

const fetchModelMatrix = ({
  legacyServicesPath,
  modelPath,
  styleId,
  config
}) => {
  const stylePath = styleId ? `/${styleId}` : '';
  const url = `${legacyServicesPath}/matrix-model/${modelPath}${stylePath}`;
  return fetchWithCache(url).then(data => normalizeModelMatrix(data, config));
};

export default fetchModelMatrix;
